import _ from "../../../../@lodash";

const CourseModel = (data) =>
  _.defaults(data || {}, {
    title: "",
    label: "",
    classification: "language",
    progress: {
      development: 0,
      production: 0,
    },
    status: {
      development: "not_started",
      production: "not_started",
    },
    order: 0,
    enrichment_link: "",
    project: "",
    language: {
      title: "English",
      acronym: "en",
      rtl: false,
    },
  });

export default CourseModel;
